import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../types/Auth";
import { RootState } from "../store";

interface UserState {
	user: User | null | undefined;
}

const initialState = {
	user: undefined,
} as UserState;

export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		clearContactState(state) {
			state.user = null;
		},
		setUser(state, action: PayloadAction<User>) {
			state.user = action.payload;
		},
	},
});

export const { setUser, clearContactState } = userSlice.actions;

export const isAuthenticated = (state: RootState) => state.user.user !== null || state.user.user !== undefined;
export const selectUser = (state: RootState) => state.user.user;
export const selectIsEngineer = (state: RootState) => state.user.user?.authentication_type === "engineer";
